import { render, staticRenderFns } from "./strapColorOptions.vue?vue&type=template&id=685b0bb3&scoped=true&"
import script from "./strapColorOptions.vue?vue&type=script&lang=js&"
export * from "./strapColorOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b0bb3",
  null
  
)

export default component.exports